import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiGallection } from '@wix/da-papi-types';
import StudioBreadcrumbs from '../../../StudioBreadcrumbs';
import BaseHeader from '../BaseHeader/BaseHeader';
import CreateFolderButton from '../../../CreateFolderButton';
import SimpleUploadButton from '../../../SimpleUploadButton';
import FolderActionsDropdown from '../../../_partials/FolderActionsDropdown';

export interface Props {
  selectedFolder: PapiGallection;
  hasSubfolders?: boolean;
  isRootStashFolder?: boolean;
  className?: string;
}

const StashHeader: FC<Props> = ({
  selectedFolder,
  hasSubfolders,
  isRootStashFolder,
  className,
}) => {
  const { t } = useTranslation();
  const showCreateFolderButton = !hasSubfolders;
  return (
    <BaseHeader
      className={className}
      titleSlot={<StudioBreadcrumbs />}
      actions={
        <>
          {showCreateFolderButton && (
            <CreateFolderButton
              label={t('studio.header.createFolder')}
              folderType="stash"
            />
          )}
          <SimpleUploadButton label={t('studio.header.upload')} />
          {!isRootStashFolder && (
            <FolderActionsDropdown
              folder={selectedFolder}
              withCreateFolder={!showCreateFolderButton}
              withBookmark
            />
          )}
        </>
      }
    />
  );
};
StashHeader.displayName = 'StashHeader';

export default StashHeader;
